module.exports = __webpack_public_path__ + "static/logo-maxipack-alpha-646c79e8d15ed03cfe1b19ddf5096b3a.svg";